import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const token = localStorage.getItem('token') ?? '';
const authType = localStorage.getItem('authType');
const vaultId = sessionStorage.getItem('vaultId');

// header configuration
const customBaseQuery = fetchBaseQuery({
  baseUrl: 'https://hvmf34.baymain.com/REST',
  prepareHeaders: (headers) => {
    headers.set('Accept', 'application/json');
    headers.set('Content-Type', 'application/json');
    if (authType === 'MFiles') {
      // so we do not set an Authorization header.
      // If you need any special header for MFiles, set it here.
    } else {
      headers.set('Authorization', `Bearer ${token}`);
      if (vaultId) {
        headers.set('X-Vault', vaultId);
      }
    }
    return headers;
  },
});

export const api = createApi({
  reducerPath: 'm-FilesAPI',
  baseQuery: customBaseQuery,
  tagTypes: ['ObjectTypes'],
  endpoints: (builder) => ({
    getObjectTypes: builder.query({
      query: () => ({
        url: `/structure/objecttypes?`,
        method: 'GET',
        params: {
          type: 'real',
          auth: token,
        },
      }),
      providesTags: ['ObjectTypes'],
    }),
  }),
});

export const { useGetObjectTypesQuery, useLazyGetObjectTypesQuery } = api;
